<template>
    <div>
        <vs-alert :title="lesson.short_load_type" active="true" style="width: 250px" class="mt-5">
            <!--Дисциплина-->
            <!-- <span class="md-body-2">{{ $t(`discipline`) }}: </span> -->
            <vx-tooltip position="right" :text="$t(`discipline`) + ': ' + lesson.discipline.name ">
                  <p
                class="md-body-1 crop-line"
                style="cursor: pointer;"
                @click="sendRequest('discipline', lesson.discipline.uid)"
                >{{ lesson.discipline.name }}</p
            >
            </vx-tooltip>

            <vs-divider />

            <!--Преподы-->
            <!-- <span
                >{{ $t(`teacher${lesson.teachers.length > 1 ? "s_2" : ""}`) }}:
            </span> -->
            <template v-if="lesson.teachers.length > 1">
                <ul class="list-in-lesson">
                    <li
                        v-for="teacher in lesson.teachers"
                        :key="teacher.profileId"
                    >
                        <vx-tooltip position="right" :text="$t(`teacher${lesson.teachers.length > 1 ? 's_2' : ''}`) + ':' + teacher.full_name">
                            <span
                                style="cursor: pointer;"
                                @click="sendRequest('teacher', teacher.uid)"
                            >
                              {{ teacher.name }}
                            </span>
                        </vx-tooltip>
                    </li>
                </ul>
            </template>
            <template v-else>
                <vx-tooltip
                    position="right"
                    :text=" $t(`teacher${lesson.teachers.length > 1 ? 's_2' : ''}`) + ': ' + lesson.teachers[0].full_name"
                >
                    <span
                        style="cursor: pointer;"
                        @click="sendRequest('teacher', lesson.teachers[0].uid)"
                    >
                        {{ lesson.teachers[0].name }}
                    </span>
                </vx-tooltip>
            </template>
            <vs-divider v-if="lesson.classroom"/>

            <!--Аудитория-->
            <!-- <span class="md-body-2">{{ $t(`cabinet`) }}: </span> -->
            <vx-tooltip position="right" v-if="lesson.classroom" :text="$t(`cabinet`)">
        <span
                        class="md-body-1"
                        style="cursor: pointer;"
                        @click="sendRequest('cabinet', lesson.classroom.uid)"
                        >{{ lesson.classroom.name }} ({{
                            lesson.classroom.capacity
                        }})</span
                    >
            </vx-tooltip>

            <vs-divider />
            <!--Группы-->
            <!-- <span class="md-body-2"
                >{{ $t(`groupp${lesson.groups.length > 1 ? "s" : ""}`) }}:
            </span> -->
            <vx-tooltip position="right" :text="$t(`groupp${lesson.groups.length > 1 ? 's' : ''}`) ">

            <template v-if="lesson.groups.length > 1">
                <ul class="list-in-lesson">
                    <li v-for="group in lesson.groups" :key="group.uid">
                        <span
                            class="md-body-1"
                            style="cursor: pointer;"
                            @click="sendRequest('group', group.uid)"
                            >{{ group.name }}</span
                        >
                    </li>
                </ul>
            </template>
            <template v-else>
                <span
                    class="md-body-1"
                    style="cursor: pointer;"
                    @click="sendRequest('group', lesson.groups[0].uid)"
                    >{{ lesson.groups[0].name }}</span
                >
            </template>
             </vx-tooltip>
        </vs-alert>
    </div>
</template>

<script>
export default {
    name: "lesson",
    props: {
        lesson: {
            type: Object,
        },
    },
    data() {
        return {
            url: this.$route.name,
            params: ["group", "discipline", "teacher", "cabinet"],
        };
    },
    created() {},
    methods: {
        sendRequest(key, data) {
            // Вставка выбранного параметр и очистка всех других

            let queries = { ...this.$route.query };
            const date = queries["date"];
            this.$router.replace({ name: this.$route.name, query: {} });

            queries = {};
            queries["date"] = date;

            queries[key] = data;

            // Записываю объект в квери урл
            this.$router.replace({ name: this.$route.name, query: queries });
        },
    },
};
</script>

<style  lang="scss">
.crop-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
